export const NO_SHOW_PATHS = [
  'account/verify-email',
  'account/verify-email-success',
  'region-selection'
];
